export enum DeepLinkParametersEnum {
  quoteToolMode = 'quoteToolMode',
  languageCode = 'languageCode',
  schoolCode = 'schoolCode',
  courseCode = 'courseCode',
  packageCode = 'packageCode',
  duration = 'duration',
  accommodationCode = 'accommodationCode',
  arrivalTransferCode = 'arrivalTransferCode',
  departureTransferCode = 'departureTransferCode',
  insuranceCode = 'insuranceCode',
  startDate = 'startDate',
  endDate = 'endDate',
  classStartTime = 'classStartTime',
  classEndTime = 'classEndTime',
  optOutProductCode = 'optOutProductCode',
  optOutProductInfo = 'optOutProductInfo',
  deeplinkType = 'type',
}
